import { ContactAdresse } from './contact-adresse';
import { BaseContact } from './base-contact';
import { Adresse } from './adresse';

import { Langue } from '../global/langue';
import { TypeContact } from '../global/type-contact';
import { User } from '../global/user';
import { SocieteFormeJuridique } from '../global/societe-forme-juridique';
import { ContactCountryDto, ContactMembersLinksDto } from 'src/app/shared/interfaces';

export class Contact {
  public listContactsAdresses?: ContactAdresse[];
  public baseSurContact: number;
  public listSocieteLies: BaseContact[];
  public id: number;
  public user: User;
  public typeContact: TypeContact;
  public typeSociete?: boolean; // true if it's a company
  public titre?: string;
  public label: string;
  public value: number;
  public nom?: string;
  public prenom?: string;
  public nomInterne?: string;
  public fonction?: string;
  public langue?: Langue;
  public nePlusUtiliser?: boolean;
  public membrePersonnel?: boolean;
  public numeroCarteNISS?: string;
  public pasDeRNBelge?: boolean;
  public dateNaissance?: string; // ($date-time)
  public naissanceLieu?: string; // ($date-time)
  public dateDeces?: string; // ($date-time)
  public etatCivil?: string;
  public sexe?: string;
  public nationalite?: string;
  public radiationRN?: boolean;
  public radiationRNDate?: string; // ($date - time)
  public numeroMatricule?: string;
  public numeroRegistrePersonnel?: string;
  public dateEntreeFonction?: string; // ($date - time)
  public dateSortieFonction?: string; // ($date - time)
  public fonctionES?: string;
  public secteurActivite: string;
  public gerantSociete?: string;
  public societeFormeJurIdique: SocieteFormeJuridique;
  public societeParente?: number;
  public societeParenteLienEtablissement?: string;
  public commentaires: string;
  public signatureCertifactNom?: string;
  public signatureDescription?: string;
  public signature1?: string;
  public signature2?: string;
  public comptaCodeClient?: string;
  public comptaCodeFournisseur?: string;
  public comptaPaiementClient?: string;
  public comptaPaiementFournisseur?: string;
  public comptaNom1?: string;
  public comptaNom2?: string;
  public comptaBanqueIBAN?: string;
  public compteBanque?: string;
  public compteBanque2?: string;
  public tva?: string;
  public tvA_Digits?: string;
  public pasDeTVABelge?: boolean;
  public siteWeb?: string;
  public siteWeb2?: string;
  public accesModuleExterneDelibe?: boolean;
  public accesModuleExterneCourrier?: boolean;
  public accesModuleExternePST?: boolean;
  public adressePrincipale: Adresse;
  public verrouille?: boolean;
  public eProjectActif?: boolean;
  public eProjectLogin?: string;
  public eProjectPassword?: string;
  public eProjectLangue?: string;
  public bce?: string;
  public exchangeMailLogin?: string;
  public contactIdReferenceInterne?: number;
  public createD_BY?: string;
  public createD_ON?: string; // ($date - time)
  public modifY_BY?: string;
  public modifI_ON?: string; // ($date - time)
  public createD_BY_USERId?: number;
  public modifieD_BY_USERId?: number;
  public typeContactName: string;
  public typeContactID: number;
  public paysContactID: number; // for tva
  // Fields for superListSimple
  public name?: string;
  public mail: string;
  public gsm: string;
  public impression_CodePostal: string;
  public impression_Localite: string;
  public impression_Adresse: string;
  public contactParent;
  public contactParentId?: number;
  public isCompany = false;
  public adressePrincipaleId?: number;
  public userActive?: boolean;
  public userId?: number;
  public adresse;

  public contactID?;
  public contactId?;
  public langueId: number;

  listContactsLiensMembres: ContactMembersLinksDto[];
  typeContactId: number;
  typeContactLabel?: string;
  firstname: string;
  lastname: string;
  fullname: string;
  loginDelibeWeb: string;
  createD_BY_USERID: number;
  modifieD_BY_USERID: number;
  paysContact: ContactCountryDto;
  societe: string;

  constructor(data?) {
    Object.assign(this, data);
    this.name = (this.prenom ? this.prenom : '') + ' ' + (this.nom ? this.nom : '');
    this.fullname = this.name;
    this.label = (this.prenom ? this.prenom : '') + ' ' + (this.nom ? this.nom : '');
    this.value = this.id;
    this.isCompany = this.typeSociete;
    if (this.typeContact) {
      this.typeContactName = this.typeContact.typeContact;
      this.typeContactID = this.typeContact.id;
    }
    if (this.adressePrincipale) {
      this.mail = this.adressePrincipale.mail;
      if (this.adressePrincipale.gsm) {
        this.gsm = this.adressePrincipale.gsm.replace(/\s/g, '');
      }
      this.impression_CodePostal = this.adressePrincipale.impression_CodePostal;
      if (this.adressePrincipale.impression_Localite) {
        this.impression_Localite = this.adressePrincipale.impression_Localite.toLowerCase();
      }
      if (this.adressePrincipale.impression_Adresse) {
        this.impression_Adresse = this.adressePrincipale.impression_Adresse.toLowerCase();
      }
    }
  }

  setName(name: string) {
    return (this.name = name);
  }
}
export class ContactInfosComplementary {
  type: string;
  societeParente?: string;
  impression_Adresse: string;
  impression_CodePostal: string;
  impression_Localite: string;
  impression_Pays: string;
  gsm: string;
  telephone: string;
  mail: string;
}
